import { useEffect, useRef } from "react";

export function useOutside(handler, capture = false) {
  const refe = useRef();

  useEffect(() => {
    function handleClick(e) {
      if (!refe.current?.contains(e.target)) {
        handler(false);
      }
    }

    document.addEventListener("click", handleClick, capture);

    return () => {
      document.removeEventListener("click", handleClick, capture);
    };
  }, [handler, capture]);

  return refe;
}
